<style lang="scss">
  .product-list-detail {
    margin-top: 20px;
    font-size: 12px;

    h3 {
      background: #eee;
      padding: 10px 15px;
      font-size: 14px;
      font-weight: normal;
    }
  }

  .no-batch-number-info {
    padding: 5px;
  }
</style>
<template>
  <div v-loading="doing" v-show="form.goodsId">
    <div v-show="batchNumbers.length">
      <div class="product-list-detail">
        <h3>批号库存信息（{{form.goodsName}}）</h3>
        <table class="table">
          <thead>
          <tr>
            <th>
              <el-checkbox @change="checkAll" v-model="isCheckAll"></el-checkbox>
            </th>
            <th>产品数量</th>
            <th style="width: 120px">批号</th>
            <th>{{this.baseForm && !this.baseForm.qualifiedFlag ? '不合格库存': '合格库存'}}</th>
            <th style="width: 150px">供货单位</th>
            <th>生产日期</th>
            <th>有效期</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for=" item in batchNumbers" :key="item.no">
            <td>
              <el-checkbox v-model="item.isChecked"></el-checkbox>
            </td>
            <td>
              <el-input style="width:160px" type="number" v-model.number="item.productCount" :min="0"
                        @blur="changeValue(item)">
                <template slot="append">
                  <dict :dict-group="'measurementUnit'" :dict-key="form.measurementUnit"></dict>
                </template>
              </el-input>
            </td>
            <td>
              {{ item.batchNumber }}
              <div class="f-grey" v-if="item.logisticsCentreName">
                <el-tooltip content="物流中心" placement="right">
                  <span>{{ item.logisticsCentreName }}</span>
                </el-tooltip>
              </div>
              <el-tag v-show="item.isOutDate" type="danger">已过期</el-tag>
            </td>
            <td>{{ item.count }}</td>
            <td>{{item.supplyManufacturersName}}</td>
            <td>{{ item.productionDate | date }}</td>
            <td>{{ item.expirationDate | date }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-show="!batchNumbers.length">
      <h2 class="no-batch-number-info">无库存批次信息</h2>
    </div>
  </div>
</template>
<script>
  import orderMixin from '@/mixins/orderMixin';
  import {BspStock} from '@/resources';

  export default {
    mixins: [orderMixin],
    props: {
      form: {},
      edited: Boolean,
      baseForm: Object
    },
    data() {
      return {
        batchNumbers: [],
        doing: false,
        isCheckAll: false
      };
    },
    watch: {
      form(val) {
        this.resetForm();
        if (!val.goodsId) return;
        this.queryBatchNumbers(val.goodsId);
      }
    },
    methods: {
      queryBatchNumbers(val) {
        let type = this.$route.meta.type;
        let orgId = type === 0 ? this.baseForm.downstreamOrgDhsId : this.baseForm.upstreamOrgDhsId;
        if (!orgId) {
          return this.$notify.info(type === 0 ? '请选择来源单位' : '请选择货主');
        }
        const params = {
          goodsId: val,
          orgId: orgId,
          logisticsCentreId: this.baseForm.thirdLogisticsDhsId && this.baseForm.logisticsCentreId || ''
        };
        this.doing = true;
        BspStock.queryOrgStockList(params).then(res => {
          res.data.forEach(i => {
            i.isOutDate = i.expiryDate < new Date(this.$moment(Date.now()).format('YYYY-MM-DD')).getTime();
          });
          this.batchNumbers = res.data.filter(f => { // unqualifiedBizCount
            return this.baseForm.qualifiedFlag ? f.availableCount : f.unqualifiedBizCount
          }).map(m => ({
            productCount: '',
            batchNumber: m.batchNumber,
            batchNumberId: m.batchNumberId,
            count: this.baseForm.qualifiedFlag ? m.availableCount : m.unqualifiedBizCount,
            productionDate: m.productionDate,
            expirationDate: m.expiryDate,
            supplyManufacturersName: m.supplyManufacturersName,
            supplyManufacturersId: m.supplyManufacturersId,
            supplyManufacturersCode: m.supplyManufacturersCode,
            isChecked: false,
            isOutDate: m.isOutDate
          })).sort((pre, cur) => pre.expirationDate - cur.expirationDate);
          this.handleEdit();
          this.doing = false;
        });
      },
      handleEdit() {
        if (!this.edited) return;
        let item = this.batchNumbers.find(i => i.batchNumberId === this.form.batchNumberId);
        if (!item) return;
        item.productCount = this.form.amount;
        item.isChecked = true;
        if (!this.form.id) return;
        // 编辑订单, 加回对应库存
        let goodsItem = this.order.details.find(f => f.batchNumberId === this.form.batchNumberId);
        if (!goodsItem) return;
        item.count += goodsItem.amount;
      },
      checkAll(val) {
        this.batchNumbers.forEach(l => {
          l.isChecked = val;
        });
      },
      changeValue(item) {
        if (item.productCount > item.count) {
          this.$notify.warning({
            duration: 2000,
            message: '输入的产品数量大于可用库存'
          });
        }
        if (item.productCount < 0) {
          this.$notify.warning({
            duration: 2000,
            message: '输入的产品数量不能为负数'
          });
        }
        item.isChecked = item.productCount > 0;
      },
      resetForm() {
        this.batchNumbers = [];
        this.isCheckAll = false;
      }
    }
  };
</script>
